import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRegistration } from '../store/RegistrationContext';

export default function ProtectedRoute() {
  const { state } = useRegistration();
  const location = useLocation();

  if (!state.auth.isAuthenticated) {
    const from = `${location.pathname}${location.search || ''}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return <Outlet />;
}
